import React, { useState } from 'react';

function SurveyStepOne({ onNext }) {
    const [agreed, setAgreed] = useState(true); // default to true so the button is active

    return (
        <div className="step-form">
            <div className="success-icon survey_icon mb-4">
                <img src="/assets/icon_start.png" alt="Survey Icon" />
            </div>

            <h6 className="mb-3 font_bebas">Staff Feedback Survey</h6>
            <p className="mb-4">Your voice matters in shaping our workplace.</p>

            <div className="text-start max-w-500 mx-0 mb-4">
                <ul className="list-unstyled">
                    <li className="d-flex align-items-center mb-3">
                        <img src="/assets/success_icon.png" alt="Check Icon" /> Completely anonymous
                    </li>
                    <li className="d-flex align-items-center mb-3">
                        <img src="/assets/success_icon.png" alt="Check Icon" /> Takes about 10 minutes
                    </li>
                    <li className="d-flex align-items-center">
                        <img src="/assets/success_icon.png" alt="Check Icon" /> Helps us improve together
                    </li>
                </ul>
            </div>

            <button
                className="btn btn-dark px-4 mt-4"
                onClick={() => onNext({ agreed })}
                disabled={!agreed}
            >
                Begin Survey
            </button>
        </div>
    );
}

export default SurveyStepOne;
